import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    // Page à retrouver après connexion : ?next=… ou, après une inscription (l'e-mail de
    // vérification fait perdre le paramètre), la page mémorisée (ex. formulaire Talent).
    const next = params.get("next") || (() => { try { return localStorage.getItem("mboa_next") || "/"; } catch { return "/"; } })();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Connexion réussie");
            // Route to the dashboard matching the user's role.
            const role = res.user?.role;
            const roleDashboard = {
                admin: "/admin",
                artist: "/artist",
                provider: "/me/profile",
                organizer: "/me/profile",
                media: "/me/profile",
                client: "/",
            }[role] || "/";
            const target = next !== "/" ? next : roleDashboard;
            try { localStorage.removeItem("mboa_next"); } catch { /* stockage indisponible */ }
            nav(target);
        } else {
            setError(res.error);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="login-page">
            <div className="w-full max-w-md bg-[#161616] border border-[#262626] rounded-2xl p-8">
                <h1 className="font-display text-3xl font-semibold tracking-tight">Connexion</h1>
                <p className="mt-2 text-sm text-[#A8A8A8]">Ravi de te revoir.</p>

                <form onSubmit={submit} className="mt-8 space-y-4">
                    <div>
                        <label className="text-xs uppercase tracking-widest text-[#6E6E6E]">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="mt-1 w-full bg-[#0F0F0F] border border-[#262626] focus:border-[#00A86B] rounded-lg px-4 py-3 focus:outline-none"
                            data-testid="login-email-input"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-[#6E6E6E]">Mot de passe</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="mt-1 w-full bg-[#0F0F0F] border border-[#262626] focus:border-[#00A86B] rounded-lg px-4 py-3 focus:outline-none"
                            data-testid="login-password-input"
                        />
                    </div>
                    {error && <p className="text-sm text-[#E53E3E]" data-testid="login-error">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-[#00A86B] hover:bg-[#00C97E] disabled:opacity-60 text-[#0F0F0F] font-semibold px-6 py-3 rounded-full transition-colors"
                        data-testid="login-submit-button"
                    >
                        {loading ? "Connexion…" : "Se connecter"}
                    </button>
                </form>

                <p className="mt-4 text-center">
                    <Link to="/forgot-password" className="text-xs text-[#A8A8A8] hover:text-[#00A86B] hover:underline" data-testid="login-forgot-link">
                        Mot de passe oublié ?
                    </Link>
                </p>

                <p className="mt-4 text-sm text-[#A8A8A8] text-center">
                    Pas encore de compte ? <Link to="/register" className="text-[#00A86B] hover:underline">S'inscrire</Link>
                </p>
            </div>
        </div>
    );
}
